import './assets/app.css';

import { loadLayout } from './app/layout';
import {
  navigate,
  startRouter,
  getCurrentPath
} from './app/router';

async function start() {

  try {

    console.log('[APP] Starting...');

    // ==========================
    // LOAD LAYOUT
    // ==========================

    await loadLayout();

    console.log('[APP] Layout loaded');

    // ==========================
    // START ROUTER
    // ==========================

    startRouter();

    // ==========================
    // SIDEBAR
    // ==========================

    document.addEventListener('click', (event) => {

      const target = event.target as HTMLElement;

      const link = target.closest(
        'a[data-route]'
      ) as HTMLAnchorElement | null;

      if (!link) {
        return;
      }

      const href = link.getAttribute('href');

      if (!href) {
        return;
      }

      event.preventDefault();

      console.log('[APP] Click route:', href);

      navigate(href);
    });

    // ==========================
    // INITIAL ROUTE
    // ==========================

    const currentPath = getCurrentPath();

    console.log(
      '[APP] Initial route:',
      currentPath
    );

    await navigate(
      currentPath,
      false
    );

    console.log('[APP] Started');

  } catch (error) {

    console.error(
      '[APP] Start error:',
      error
    );

  }
}

start();